import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      shop: 'shop',
      product: 'cart/products',
    }),

    heavyProducts() {
      return this.products.filter((product) => product.product_subcategory.shipping_type === 'heavy');
    },
  },

  methods: {
    setShippingMethod(shippingMethods, country) {
      let shippingMessage = '';
      if (this.shop.shipping_type === 'where') {
        this.$store.dispatch('cart/updateShipping', shippingMethods.find((method) => method.slug === 'international'));
        shippingMessage = this.$t('cart.shippingAbroad');
        if (country === this.shop.country_code) {
          shippingMessage = this.$t('cart.shippingNational');
          this.$store.dispatch('cart/updateShipping', shippingMethods.find((method) => method.slug === 'national'));
        }
      }
      if (this.shop.shipping_type === 'what') {
        let shipping = {
          price: 0,
        };
        this.products.forEach((product) => {
          if (product.product_subcategory.shipping_method.price > shipping.price) {
            shipping = product.product_subcategory.shipping_method;
          }
        });
        this.$store.dispatch('cart/updateShipping', shipping);
        shippingMessage = this.$t('cart.heavyShipping');
      }
      return shippingMessage;
    },
  },
};
